import config from "@src/config";
import clsx from "clsx";
import {
	PlanCard,
	PlanCta,
	PlanDescription,
	PlanLabelBadge,
	PlanPrice,
} from "./plan-modal-card-ui";

export function CustomisePlanCard(props: {
	isButtonDisabled: boolean;
}) {
	const { isButtonDisabled = false } = props;

	return (
		<PlanCard>
			<PlanLabelBadge variant="partner">Design Partner</PlanLabelBadge>

			<PlanPrice price="Custom" period="lifetime" />

			<PlanDescription>
				<div className="space-y-1">
					<p>
						We are looking for innovation teams that are struggling with
						scattered context, misalignment across functions, and too much
						knowledge trapped in individual heads. If it sounds like your team
						and you are eager to try a new approach to work, let's talk!
					</p>
				</div>
			</PlanDescription>

			<PlanCta>
				{isButtonDisabled ? (
					<button
						type="button"
						disabled
						className={clsx(
							"w-full rounded-xl h-10 text-sm font-semibold transition-all",
							"flex items-center justify-center",
							"shadow-md shadow-(--ui-color-brand-primary)/10",
							"bg-brand-primary hover:bg-brand-primary-hover text-text-inverse",
							"cursor-not-allowed opacity-60",
						)}
					>
						Get in touch
					</button>
				) : (
					<a
						href={config.enterpriseContactUrl}
						target="_blank"
						rel="noreferrer"
						className={clsx(
							"w-full rounded-xl h-10 text-sm font-semibold transition-all",
							"flex items-center justify-center",
							"shadow-md shadow-(--ui-color-brand-primary)/10",
							"bg-brand-primary hover:bg-brand-primary-hover text-text-inverse",
						)}
					>
						Get in touch
					</a>
				)}
			</PlanCta>
		</PlanCard>
	);
}
